export default "__VITE_ASSET__CDfTAzzB__"